import { Period } from 'src/models/classes';

// eslint-disable-next-line import/prefer-default-export
export function sortPeriodsByStartDateComparer(a: Period, b: Period) {
  const aMilliseconds = new Date(a.startDate).getTime();
  const bMilliseconds = new Date(b.startDate).getTime();
  return bMilliseconds - aMilliseconds;
}
